import { NextHead } from "../src/landingPage/layouts/LayoutComponents/NextHead";
import { productsCatalogApi } from "../src/api/productsCatalogApi";
import { meta } from "../src/landingPage/datasets/meta";
import { RequestDemoTemplate } from "../src/landingPage/views/Forms/templates/RequestDemoTemplate";
import { book_demo } from "../src/landingPage/datasets/forms/book_demo";

const RequestDemoPage = ({ allDataSources }) => {
  return (
    <>
      <NextHead
        currentPath="/request-demo"
        title={meta.request.title}
        description={meta.request.description}
      />
      <RequestDemoTemplate
        type="request"
        dataSources={allDataSources}
        data={book_demo}
        headerColor={book_demo.headerColor}
      />
    </>
  );
};

export const getServerSideProps = async () => {
  const sourcesData = await productsCatalogApi.getAllDataSources();
  const allDataSources = sourcesData?.data
    .filter(item => item.name.toLowerCase() !== "demystdata")
    .map(item => ({ item, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ item }) => item) // randomizing the order
    .slice(0, 30); // only take 30

  return {
    props: {
      allDataSources,
      wrapper: "MarketingWrapper",
    },
  };
};

export default RequestDemoPage;
